import { useI18n } from 'hooks/useI18n';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { SALARYOFFEREDVSWANTED } from '../Companies.constants';

const SalaryOfferedVsWanted: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');

  const salaryOfferedVsWanted = SALARYOFFEREDVSWANTED.sort((a, b) =>
    a.offer > b.offer ? -1 : 1
  );

  return (
    <div>
      <StyledRecharts className="xAxisLabel">
        <ResponsiveContainer height={650} width="99%" minWidth={700}>
          <BarChart data={salaryOfferedVsWanted}>
            <XAxis
              type="category"
              dataKey="role"
              tickLine={false}
              interval={0}
              angle={-60}
              textAnchor="end"
              height={200}
              axisLine={false}
            />
            <YAxis
              tickLine={false}
              width={60}
              axisLine={false}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              padding={{ bottom: 5 }}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toFixed(1)}K`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: 0 }}
            />
            <Bar
              dataKey="offer"
              barSize={12}
              radius={5}
              fill="#8DD3C7"
              name={t('mandecar23.companies.salary-offered-wanted.employers')}
            />
            <Bar
              dataKey="manfredite"
              barSize={12}
              radius={5}
              fill="#7EAFD3"
              name={t('mandecar23.companies.salary-offered-wanted.candidates')}
            ></Bar>
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default SalaryOfferedVsWanted;
